import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { UploaderState } from 'APP/main/ChatView/components/UploaderState/UploaderState';

import { useUploadBackgroundPresenter } from './UploadBackground.presenter';
import styles from './UploadBackground.styles.m.css';

interface UploadBackgroundProps {
  className?: string;
  file: File;
  onUploadSuccess(url: string): void;
  onCancelUpload(): void;
}

export const UploadBackground: FC<UploadBackgroundProps> = observer(
  ({ className, file, onUploadSuccess, onCancelUpload }) => {
    const presenter = useUploadBackgroundPresenter({ file, onUploadSuccess, onCancelUpload });

    return (
      <div className={classNames(className, styles.container)}>
        <div
          className={styles.preview}
          style={{ backgroundImage: `url(${presenter.url || presenter.previewUrl})` }}
        >
          {presenter.uploadProgress !== null && (
            <UploaderState
              className={styles.uploader}
              uploadFileData={{
                uploadProgress: presenter.uploadProgress,
                cancelUpload: presenter.cancelUpload,
              }}
            />
          )}
        </div>
      </div>
    );
  }
);
